import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useDashboardActivity = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery([ReactQueryKeys.DashboardActivityGateway], async () => {
    const response = await treasureApi().get('/activities');

    return response.data;
  });
};
